export enum SearchWorkflowCategoryEnum {
  NONE = "NONE",
  ID_TRADE = "ID_TRADE",
  OWNER_NAME = "OWNER_NAME",
  OWNER_DOCUMENT = "OWNER_DOCUMENT",
  PROCESS_CODE = "PROCESS_CODE"
}

export const SearchWorkflowCategoryLabel = new Map<SearchWorkflowCategoryEnum, string>([
  [SearchWorkflowCategoryEnum.NONE, "Sem filtro"],
  [SearchWorkflowCategoryEnum.ID_TRADE, "ID do Trade"],
  [SearchWorkflowCategoryEnum.OWNER_NAME, "Nome do Requerente"],
  [SearchWorkflowCategoryEnum.OWNER_DOCUMENT, "Documento do Requerente"],
  [SearchWorkflowCategoryEnum.PROCESS_CODE, "Código do processo"]
]);



// WEBPACK FOOTER //
// ./src/services/interfaces/SearchWorkflowCategoryEnum.ts